import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { DataTablePageEvent } from "primereact/datatable";
import TestReportSearch from "./TestReportSearch";
import TestReportsDatatable from "./TestReportsDatatable";
import TestReportService, {
  TestReportListRow,
  TestReportListFilter,
} from "../../services/TestReport/TestReport.service";

const TestReportsPage: React.FC = () => {
  const [rows, setRows] = useState<TestReportListRow[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState<TestReportListFilter>({
    sortColumn: "reportdate",
    sortDirection: "desc",
  });

  const fetchData = async () => {
    setLoading(true);
    try {
      const payload = { pageNumber, pageSize, ...filters };
      const res = await TestReportService.getTestReports(payload);
      setRows(res.items);
      setTotalRecords(res.totalRecords);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchData(); }, [pageNumber, pageSize, filters]);

  const onSearch = (f: Partial<TestReportListFilter>) => {
    setFilters((prev) => ({ ...prev, ...f }));
    setPageNumber(1);
  };

  const onReset = () => {
    setFilters({ sortColumn: "reportdate", sortDirection: "desc" });
    setPageNumber(1);
  };

  const onPageChange = (e: DataTablePageEvent) => {
    setPageNumber((e.page ?? 0) + 1);
    setPageSize(e.rows);
  };

  const onSortChange = (field: string, order: 1 | -1) => {
    const map: Record<string, string> = {
      reportId: "reportid",
      reportDate: "reportdate",
      testedDate: "testeddate",
      oilName: "oilname",
      batchNo: "batchno",
    };
    setFilters((p) => ({
      ...p,
      sortColumn: map[field] ?? field,
      sortDirection: order === 1 ? "asc" : "desc",
    }));
  };

  return (
    <div className="p-3">
      <Card title="Test Reports" className="mb-3">
        <TestReportSearch onSearch={onSearch} onReset={onReset} totalRecords={totalRecords} />
      </Card>

      <Card>
        <TestReportsDatatable
          data={rows}
          loading={loading}
          totalRecords={totalRecords}
          pageNumber={pageNumber}
          pageSize={pageSize}
          onPageChange={onPageChange}
          onSortChange={onSortChange}
          onRefresh={fetchData}
        />
      </Card>
    </div>
  );
};

export default TestReportsPage;
